<template>
    <v-app v-if="initialized">
        <div id="container">

            <v-row>
                <v-img
                        alt="GameEnable"
                        class="shrink mr-2"
                        contain
                        src="../../assets/logo/one-line-dark.svg"

                        width="130"
                        style="position:absolute;left:0;margin:17px 17px 10px"
                />
                <div v-if="currentPage === 'not-authenticated'" class="view not-authenticated"
                     style="padding:80px 23px;">

                    <div style="padding-top:50px">
                        <div style="text-align:center;color:#fff;margin-bottom:10px;">Sign in to continue</div>
                        <sign-in-button @completed="signInCompleted" :source="'extension'"></sign-in-button>

                    </div>


                </div>

                <div v-if="currentPage === 'authenticated-no-subscription'" class="view authenticated-no-subscription">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    icon color="deep-orange" class="sign-out"
                                    v-bind="attrs"
                                    v-on="on"
                            >
                                <v-icon color="#fff">mdi-account-circle</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="padding:0;">
                            <v-list-item
                                    style="cursor:pointer;"
                                    v-for="(item, index) in [{title: 'signout'}]"
                                    :key="index"
                                    @click="signout"

                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <span v-if="!paymentFormOpen">

                             <v-alert
                                     icon="mdi-exclamation"
                                     prominent
                                     text
                                     type="Warning"
                                     style="margin-top:30px;"
                             >
                        <div style="margin-left:10px;">No subscription</div>
                    </v-alert>
                        <v-btn class="action-button" id="purchase-button" style="width:250px!important;"
                               @click="paymentFormOpen=true" v-text="user.hadSubscription? 'Get subscription' : 'Start Free Trial'"> </v-btn>
                    </span>


                    <payment-form v-if="paymentFormOpen" :dark-theme="true" :source="'extension'"
                                  :sign-in-token="signInToken" @completed="onPaymentCompleted"></payment-form>

                </div>

                <div v-if="currentPage === 'authenticated-with-subscription'"
                     class="view authenticated-with-subscription">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                    icon color="deep-orange" class="sign-out"
                                    v-bind="attrs"
                                    v-on="on"
                            >
                                <v-icon color="#fff">mdi-account-circle</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="padding:0;">
                            <v-list-item
                                    style="cursor:pointer;"
                                    v-for="(item, index) in [{title: 'signout'}]"
                                    :key="index"
                                    @click="signout"

                            >
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <v-alert
                            v-if="connected"
                            icon="mdi-check-network"
                            prominent
                            text
                            type="success"
                    >
                        <div style="margin-left:10px;"> Connected
                        </div>
                    </v-alert>

                    <v-alert
                            v-if="connecting"
                            icon="mdi-blabla-no-icon"
                            prominent
                            text
                            type="info"
                    >
                        <v-progress-circular
                                style="position: absolute; left: 24px; top: 23px; color: #2196f3 !important;"
                                indeterminate
                                color="red"
                        ></v-progress-circular>
                        <div style="margin-left:10px;"> Finding fastest server</div>
                    </v-alert>
                    <v-alert
                            v-if="!connected && !connecting"
                            icon="mdi-close-network"
                            prominent
                            text
                            type="error"

                    >
                        <div style="margin-left:10px;">Disconnected</div>
                    </v-alert>


               <server-selection :connected="connected" :connectedTo="connectedTo" :disabled="connected || connecting" v-model="selectedServer" ></server-selection>

                    <span  v-if="false">
                        <v-alert v-bind:key="service" v-for="service in ['Stadia', 'GeForce Now']">
                        {{service}}
                        <v-switch
                                v-model="ex11"
                                style="position: absolute;right:5px;top:-4px;"
                                color="error"
                                :value="service"
                                hide-details
                        ></v-switch>
                    </v-alert>
                    </span>

                    <v-alert
                            v-if="false"
                            class="time-block"
                            color="grey"

                            icon="mdi-clock"

                            prominent
                    >
                        <div style="margin-left:10px;">{{connecteTimeUi}}</div>

                    </v-alert>
                    <v-btn
                            :loading="connecting"
                            :disabled="connecting" class="action-button" id="connect-button"

                            @click="connect">
                        {{connecting? '' : (connected? 'Disconnect' : 'Connect')}}
                    </v-btn>
                </div>

            </v-row>
            <v-bottom-sheet v-model="autoDetectTip" overlay-color="transparent" overlay-opacity="0">
                <v-sheet
                        class="text-left"
                        height="120px"
                >

                    <div class="py-3 pl-4">
                        <v-icon color="#444">mdi-speedometer</v-icon> <br>
                        <div style="margin-top:10px;">AutoDetect  may take up-to 60s to complete</div>

                    </div>
                    <v-btn
                            class="mt-6"
                            text
                            color="pink"
                            style="position:absolute;right:10px;bottom:10px;"
                            @click="autoDetectTip = !autoDetectTip"
                    >
                        Got it
                    </v-btn>
                </v-sheet>
            </v-bottom-sheet>

            <div v-if="!proxyAPIAvailable" style="position: fixed;top:55px;bottom:0;left:0;right:0;">
                <v-sheet
                        class="text-left"
                        height="350px"
                        style="background:#444;"
                >
                    <div style="position: relative; margin: auto; display: block; width: 130px; top: 20px;">


                        <v-img
                                alt="GameEnable"
                                class="shrink mr-2"
                                contain
                                src="../../assets/uncontrollable.svg"
                                width="130"
                                style="position: relative; margin: auto; display: block;"
                        />
                    </div>
                    <div class="py-3 pl-4 pr-4" style="color:#fff;">

                        <div style="margin-top:40px;text-align: center;">GameEnable cannot work because another extension is controlling your proxy settings.</div>
                        <div style="font-size:14px;margin-top:20px;text-align: center;font-weight: 300;"> Please disable other extensions that you think might control your proxy settings such as ad-blockers, other VPN services, Location changers etc.</div>


                    </div>
                    <v-btn
                            class="mt-6"
                            text
                            color="pink"
                            style="position:absolute;right:10px;bottom:10px;"
                            @click="openExtensionsTab"
                    >
                        Open Extensions
                    </v-btn>
                </v-sheet>
            </div>

            <extension-not-controllable-dialog v-model="notControllableDialog"></extension-not-controllable-dialog>
            <extension-not-controllable-dialog v-model="notControllableDialog"></extension-not-controllable-dialog>
        </div>
    </v-app>
</template>

<style scoped>

    .hide {
        display: none;
    }

    .view {

        height: 100%;
        width: 100%;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 60px 23px 0 23px;
    }

    .view.authenticated-no-subscription {
        padding: 60px 20px 0;
        overflow: hidden;
    }

    .authenticated-no-subscription #purchase-button {

        bottom: 30px;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;

    }

    .authenticated-with-subscription #connect-button {

        bottom: 30px;
        left: 0;
        right: 0;
        margin: auto;
        position: absolute;

    }

    .authenticated-with-subscription .time-block * {

        color: #fff;

    }

    .authenticated-no-subscription .no-subscription {

        position: absolute;
        top: 158px;
        left: 0;
        right: 0;
        margin: auto;
        width: 160px;
        padding: 3px;
        border-radius: 3px;
        border: 1px solid orange;
        color: orange;
        text-align: center;
        font-size: 14px;
    }

    .not-authenticated #purchase-button {

        width: 230px !important;
        position: relative;
        margin: 0 auto;

    }

    #container {

        background: #444;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;

    }

    .sign-out {

        position: absolute;
        right: 15px;
        top: 10px;
        color: #fff;
        font-size: 14px;
        font-weight: 200;

    }

    .action-button {
        width: 170px !important;
        border-radius: 50px !important;
    }

    .account-name {

        position: absolute;
        left: 10px;
        top: -7px;
        color: #fff;
        font-size: 14px;
        font-weight: 400;

    }


</style>
<style>
    body,html{overflow-y:auto!important}
</style>
<script>
    // @ is an alias to /src
    import Vue from 'vue'
    import {mapState} from 'vuex'
    import PaymentForm from '../../components/paymentForm'
    import SignInButton from '../../components/signInButton'
    import ExtensionBridge from './extensionBridge'
    import ExtensionNotControllableDialog from '../../dialogs/extensionNotControllable'

    import ServerSelection from './components/serverSelection'
    // import config from '../../config'

    export default {
        name: 'Home',
        components: {
            PaymentForm,
            SignInButton,
            ExtensionNotControllableDialog,
            ServerSelection
        },
        created() {
            Vue.$Tawk.disable();

            window.addEventListener('message', (event)=> {

                if(event.data && event.data.type === 'extensionNotControllable'){

                    this.notControllableDialog=true;
                    this.connected = false;
                    this.connecting = false;

                }

            });

        },
        async beforeMount() {

            this.connecting = this.$route.query.connecting.toUpperCase() == 'TRUE';
            this.connected = !this.connecting && this.$route.query.active.toUpperCase() == 'TRUE';
            this.proxyAPIAvailable = this.$route.query.proxyAPIAvailable.toUpperCase() == 'TRUE';
            this.authenticated = this.$route.query.authenticated.toUpperCase() == 'TRUE' && this.signInToken;
            this.connectedTime = {seconds: parseInt(this.$route.query.time)};
            this.connectedTo = this.$route.query.serverLocation || 'AutoDetect';
            this.customerEmail = this.$route.query.customerEmail || undefined;

            ExtensionBridge.register({
                connectedChange: (payload)=> this.connected = payload.connected
            });


            if (this.connected) {

                this.startCounter();

            }

            if(this.connecting){

               const result = await ExtensionBridge.waitForConnectivity();

                this.connectedTo = result.serverLocation;
                if (!result.error) {

                    this.connected = result.connected;
                    this.connecting = false;

                }

            }

        },

        data: () => ({
            connected: false,
            connectedTime: 0,
            connecting: false,
            counterIntervalId: -1,
            paymentFormOpen: false,
            notControllableDialog: false,
            autoDetectTip: false,
            serverSelectionDialog: false,
            selectedServer: undefined,
            connectedTo: undefined,
            proxyAPIAvailable:true
        }),
        watch:{
            initialized(){
                ExtensionBridge.syncUserState(this.user);
            },
            isPaymentFormOpenAndPaymentPage(to){

                if(to){
                    ExtensionBridge.resize(470)
                }else{

                    ExtensionBridge.resize(351)

                }



            }
        },
        computed: {

            ...mapState(['signedIn', 'user', "initialized", "signInToken"]),
            isPaymentFormOpenAndPaymentPage(){

                return this.paymentFormOpen && this.currentPage === 'authenticated-no-subscription';

            },
            currentPage() {

                if (!this.signedIn) {
                    return 'not-authenticated';
                }

                return this.user.haveSubscription ? 'authenticated-with-subscription' : 'authenticated-no-subscription';

            },
            connecteTimeUi() {

                let diff = this.connectedTime.seconds * 1000;


                const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                diff -= days * (1000 * 60 * 60 * 24);

                const hours = Math.floor(diff / (1000 * 60 * 60));
                diff -= hours * (1000 * 60 * 60);

                const mins = Math.floor(diff / (1000 * 60));
                diff -= mins * (1000 * 60);

                const seconds = Math.floor(diff / (1000));
                diff -= seconds * (1000);

                return `${days}:${hours}:${mins}:${seconds}`;

            }

        },
        methods: {

            async signInCompleted(payload) {

                this.$store.dispatch('signIn', payload);

                ExtensionBridge.syncUserState(this.user);

            },

            openExtensionsTab(){

                ExtensionBridge.openExtensionsTab();

            },

            async connect() {

                this.connecting = true;

                if(!this.selectedServer || this.selectedServer === "AutoDetect"){

                    if(!localStorage.sawAutoDetectTip){

                        this.autoDetectTip = true;

                        localStorage.sawAutoDetectTip = true;

                    }


                }

                const result = this.connected ? await ExtensionBridge.disconnect() : await ExtensionBridge.connect(this.selectedServer);

                this.connectedTo = result.serverLocation;

                clearInterval(this.counterIntervalId);

                if (!result.error) {

                    this.connected = result.connected;
                    this.connecting = false;

                }

            },

            signout() {

                ExtensionBridge.disconnect();

                ExtensionBridge.clearUserState();

                this.connected = false;

                this.$store.dispatch('signOut', {navigate: false});

            },

            startCounter() {

                this.counterIntervalId = setInterval(() => {

                    this.connectedTime.seconds++;

                    this.connectedTime = {...this.connectedTime};

                }, 1000);

            },

            async onPaymentCompleted(responseJSON) {

                //Stripe
                if(responseJSON.status === 'SUCCESS'){

                     this.signInToken && this.$store.dispatch('syncUser', this.signInToken);

                    ExtensionBridge.subscriptionCreated();

                    this.$UAnalytics.subscribed();

                }

            }

        }
    }
</script>
